import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Download, RefreshCcw, Loader2 } from "lucide-react";
import ReportView from "../../components/ReportView";
import { api, errMsg, downloadPdf } from "../../lib/api";

export default function CustomerReport() {
  const { iid } = useParams();
  const [ins, setIns] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/inspections/${iid}`).then(({ data }) => setIns(data)).catch((e) => toast.error(errMsg(e))); }, [iid]);
  const pdf = async () => { setBusy(true); try { await downloadPdf(iid); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const request = async () => {
    try { await api.post(`/inspections/${iid}/reinspection`, {}); toast.success("Re-inspection requested. Our team will schedule it."); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!ins) return <div className="grid place-items-center py-24"><Loader2 className="h-6 w-6 animate-spin text-teal-600" /></div>;
  const btn = "tap flex h-11 items-center gap-2 rounded-md px-4 text-sm font-semibold";
  return (
    <ReportView ins={ins} actions={<>
      <button onClick={pdf} className={`${btn} bg-teal-500 text-slate-950 hover:bg-teal-400`} data-testid="customer-download-pdf-button">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} Download PDF</button>
      <button onClick={request} className={`${btn} border border-slate-700 text-white hover:bg-slate-800`} data-testid="customer-request-reinspection-button"><RefreshCcw className="h-4 w-4" /> Request re-inspection</button>
    </>} />
  );
}
